<template>
  <div id="specialReportsPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="گزارشات ویژه"></ActionBar>
<!--    <div class="row container mx-auto p-sm-0 mt-2">
      <div class="col-12 mb-4 p-0">
        <div class="rounded-xl bg-report-shadow bg-special-report">
          <div class="p-2">
            <img alt="گزارشات ویژه" class="img-fluid" src="../assets/img/report.png"><span
              class="white&#45;&#45;text mr-1 font16px">گزارشات ویژه</span>
            <div class="white&#45;&#45;text mt-4">{{ text }}</div>
          </div>
        </div>
      </div>
    </div>-->
    <div class="row container mx-auto p-0 mt-2">
      <div v-for="item in items" :key="item.ReportCategoryID" class="col-6 col-md-4 p-1 col-lg-3 my-2">
        <div v-if="item.Color !== null" class="ribbon ribbon-top-right"><span
            :style="'background-color:'+item.Color"></span></div>
        <div class="bg-white round12px special-report-height p-1 cursor-pointer"
             @click="goToSpecialReportDetail(item.PackageIDs,item.packagesName,item.ReportCategoryID, item.Name)">
          <v-img v-if="item.FileUrl !== null" :src="$replaceHttps(item.FileUrl)" max-height="100" min-height="100" contain>
          </v-img>
          <v-img v-else contain max-height="100" min-height="100" src="../assets/img/pishroLogo.png">
          </v-img>
          <div class="text-center mt-2 font12px mt-1 end-of-div">{{ item.Name }}</div>
        </div>
      </div>
    </div>

    <FooterMenu/>
    <v-dialog
        v-model="showBuyPackageDialog"
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ buyDialogText }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3 justify-space-around">
          <v-btn class="px-8" color="forth" rounded @click="showBuyPackageDialog = !showBuyPackageDialog">
            <span class="white--text">بستن</span>
          </v-btn>
          <v-btn class="px-8" color="primary" rounded @click="goToBuyMemberShip">
            لیست پکیج ها
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null;
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";

export default {
  name: "SpecialReports",
  metaInfo: {
    title: 'مسیربرتر-گزارشات ویژه'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    text: 'لورم ایپسوم یا طرح‌نما (به انگلیسی: Lorem ipsum) به متنی آزمایشی و بی‌معنی در صنعت چاپ، صفحه‌آرایی و طراحی گرافیک گفته می‌شود. طراح گرافیک از این متن به عنوان عنصری از ترکیب بندی برای پر کردن صفحه و ارایه اولیه شکل ظاهری و کلی طرح سفارش گرفته شده استفاده می نماید، تا از نظر گرافیکی نشانگر چگونگی نوع و اندازه فونت و ظاهر متن باشد. ',
    items: [],
    activePackages: null,
    packages: [],
    showBuyPackageDialog: false,
    showLoaderDialog: false,
    buyDialogText: ''
  }),

  mounted() {
    _this = this;


    this.getPackagePayHistoryData()
    this.getPackages()
  },
  methods: {
    getData() {
      this.showLoaderDialog= true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportCategoryManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            let packages = _this.packages
            for (let i = 0; i < json.length; i++) {
              //json[i].packagesName = []
              if (json[i].PackageIDs !== null) {
                for (let j = 0; j < json[i].PackageIDs.length; j++) {
                  if (json[i].packagesName === undefined) {
                    json[i].packagesName = [];
                  }
                  let find = packages.find(x => x.PackageID === json[i].PackageIDs[j])
                  json[i].packagesName.push(find.Name)
                }
              }
            }
            this.showLoaderDialog= false
            _this.items = json

          })
          .catch(error => console.log('error', error));
    },
    getPackagePayHistoryData() {
      this.showLoaderDialog = true
     let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let now = this.$convertDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10))

      let date = new Date()
      date.setFullYear(date.getFullYear() - 1)
      let yearAgo = this.$convertDate(new Date(date - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10))

      let urlencoded = new URLSearchParams();

      urlencoded.append("AppUserID", this.$getUserData().userID);
      urlencoded.append("StartDate", yearAgo);

      urlencoded.append("EndDate", now);


      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageReportManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false
            let json = JSON.parse(result)
            _this.activePackages = json.filter(x => x.IsExpire === false)
          })
          .catch(error => console.log('error', error));
    },
    getPackages() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "PackageManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.packages = JSON.parse(result)
            _this.getData()
          })
          .catch(error => console.log('error', error));
    },
    goToSpecialReportDetail(packageID, name,ReportCategoryID,reportName) {

      let activePackages = this.activePackages
      let findPackage =[]
      if(packageID !== null) {
        for (let i = 0; i < packageID.length; i++) {
          findPackage.push(activePackages.filter(x => x.PackageID === packageID[i]))
        }
        if (findPackage[0].length <= 0) {
          this.showBuyPackageDialog = true
          if (name.length === 1) {
            this.buyDialogText = 'برای دسترسی به این گزارش باید   پکیج  ' + name[0] + '، را خریداری کنید'

          } else {
            let text = ''
            for (let i = 0; i < name.length; i++) {
              text += name[i] + '،'
            }
            this.buyDialogText = 'برای دسترسی به این گزارش باید یکی از پکیج های ' + text + ' را خریداری کنید'
          }
        } else {
          this.$router.push({path: 'SpecialReportDetail', query: {ReportCategoryID: ReportCategoryID,Name:reportName}})
        }
      }else {
        this.$router.push({path: 'SpecialReportDetail', query: {ReportCategoryID: ReportCategoryID,Name:reportName}})

      }

    },
    goToBuyMemberShip() {
      this.$router.push({path: 'BuyMembership'})
    },
    getImgUrl(pic) {
      return require('../assets/img/' + pic)
    }
  }
}
</script>
